/* jshint node:true */
'use strict';

var createStore = require('fluxible/addons').createStore;
var PersistentStateMixin    = require('../mixins/PersistentStateMixin');

var HomeStore = createStore({

    storeName: 'HomeStore',

    mixins: [PersistentStateMixin],

    initialize: function() {
        this.data = {};
    },

    handlers: {
        RECEIVED_HOME: function(payload) {
            this.data.columns = payload.columns;
            this.emitChange();
        }
    },

    getColumn: function(columnName) {
        try {
            for (var i = 0, len = this.data.columns.length; i < len; i++) {
                var column = this.data.columns[i];
                if(column.name === columnName){
                    return column;
                }
            }
            return {};
        } catch (e) {
            return {};
        }
    },

});

module.exports = HomeStore;


/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/stores/HomeStore.js
 **/